<script>
export default {
  data(){
    return {
      statesList: [
        { label: "Wilayah Persekutuan", value: "Wilayah Persekutuan" },
        { label: "Kelantan", value: "Kelantan" },
        { label: "Johor", value: "Johor" },
        { label: "Kedah", value: "Kedah" },
        { label: "Melaka", value: "Melaka" },
        { label: "Negeri Sembilan", value: "Negeri Sembilan" },
        { label: "Pahang", value: "Pahang" },
        { label: "Penang", value: "Penang" },
        { label: "Perak", value: "Perak" },
        { label: "Perlis", value: "Perlis" },
        { label: "Sabah", value: "Sabah" },
        { label: "Sarawak", value: "Sarawak" },
        { label: "Selangor", value: "Selangor" },
        { label: "Terengganu", value: "Terengganu" }
      ],
      bankList: [
        {text: "AFFIN BANK BERHAD", value: "AFFIN BANK BERHAD"},
        {text: "AL RAJHI BANKING AND INVESTMENT CORPORATION (MALAYSIA) BHD", value: "AL RAJHI BANKING AND INVESTMENT CORPORATION (MALAYSIA) BHD"},
        {text: "ALLIANCE BANK MALAYSIA BERHAD", value: "ALLIANCE BANK MALAYSIA BERHAD"},
        {text: "AMBANK (M) BERHAD", value: "AMBANK (M) BERHAD"},
        {text: "BANGKOK BANK BERHAD", value: "BANGKOK BANK BERHAD"},
        {text: "BANK ISLAM MALAYSIA BERHAD", value: "BANK ISLAM MALAYSIA BERHAD"},
        {text: "BANK KERJASAMA RAKYAT MALAYSIA BERHAD", value: "BANK KERJASAMA RAKYAT MALAYSIA BERHAD"},
        {text: "BANK MUAMALAT MALAYSIA BERHAD", value: "BANK MUAMALAT MALAYSIA BERHAD"},
        {text: "BANK OF AMERICA (MALAYSIA) BERHAD", value: "BANK OF AMERICA (MALAYSIA) BERHAD"},
        {text: "BANK OF CHINA (MALAYSIA) BERHAD", value: "BANK OF CHINA (MALAYSIA) BERHAD"},
        {text: "BANK OF TOKYO-MITSUBISHI UFJ (MALAYSIA) BERHAD", value: "BANK OF TOKYO-MITSUBISHI UFJ (MALAYSIA) BERHAD"},
        {text: "BANK PERTANIAN MALAYSIA BHD (AGROBANK)", value: "BANK PERTANIAN MALAYSIA BHD (AGROBANK)"},
        {text: "BANK SIMPANAN NASIONAL BERHAD", value: "BANK SIMPANAN NASIONAL BERHAD"},
        {text: "BNP PARIBAS MALAYSIA BERHAD", value: "BNP PARIBAS MALAYSIA BERHAD"},
        {text: "CIMB BANK BERHAD", value: "CIMB BANK BERHAD"},
        {text: "CITIBANK BERHAD", value: "CITIBANK BERHAD"},
        {text: "DEUTSCHE BANK (MALAYSIA) BERHAD", value: "DEUTSCHE BANK (MALAYSIA) BERHAD"},
        {text: "HONG LEONG BANK BERHAD", value: "HONG LEONG BANK BERHAD"},
        {text: "HSBC BANK MALAYSIA BERHAD", value: "HSBC BANK MALAYSIA BERHAD"},
        {text: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA", value: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA"},        
        {text: "J.P.MORGAN CHASE BANK BERHAD", value: "J.P.MORGAN CHASE BANK BERHAD"},
        {text: "KUWAIT FINANCE HOUSE (MALAYSIA) BERHAD", value: "KUWAIT FINANCE HOUSE (MALAYSIA) BERHAD"},
        {text: "MALAYAN BANKING BERHAD (MAYBANK)", value: "MALAYAN BANKING BERHAD (MAYBANK)"},
        {text: "MBSB BANK BERHAD", value: "MBSB BANK BERHAD"},
        {text: "MIZUHO CORPORATE BANK (MALAYSIA) BERHAD", value: "MIZUHO CORPORATE BANK (MALAYSIA) BERHAD"},
        {text: "OCBC AL-AMIN BANK BERHAD", value: "OCBC AL-AMIN BANK BERHAD"},
        {text: "OCBC BANK (MALAYSIA) BERHAD", value: "OCBC BANK (MALAYSIA) BERHAD"},
        {text: "PUBLIC BANK BERHAD", value: "PUBLIC BANK BERHAD"},
        {text: "RHB BANK BERHAD", value: "RHB BANK BERHAD"},
        {text: "STANDARD CHARTERED BANK MALAYSIA BERHAD", value: "STANDARD CHARTERED BANK MALAYSIA BERHAD"},
        {text: "SUMITOMO MITSUI BANKING CORPORATION", value: "SUMITOMO MITSUI BANKING CORPORATION"},
        {text: "UNITED OVERSEAS BANK (MALAYSIA) BERHAD", value: "UNITED OVERSEAS BANK (MALAYSIA) BERHAD"},
      ]
    }
  },
  methods: {
    dateTimeFormatter(dateTime) {
      return [this.dateFormatter(dateTime), this.timeFormatter(dateTime)];
    },
    dateFormatter(dateTime) {            
      let formattedDate =
        this.dateTimeFormatterAppendLeadingZero(dateTime.getDate()) +
        "-" +
        this.dateTimeFormatterAppendLeadingZero(dateTime.getMonth()+1) +
        "-" +
        dateTime.getFullYear();
      return formattedDate;
    },
    timeFormatter(dateTime) {
      let twelveHourFormat;
      let hours = this.dateTimeFormatterAppendLeadingZero(dateTime.getHours());
      if (hours >= 0 && hours <= 12) {
        twelveHourFormat = "AM";
      } else if ((hours > 12 && hours <= 23) || hours == 0) {
        hours = hours - 12;
        twelveHourFormat = "PM";
      }
      let formattedTime =
        hours +
        ":" +
        this.dateTimeFormatterAppendLeadingZero(dateTime.getMinutes()) +
        ":" +
        this.dateTimeFormatterAppendLeadingZero(dateTime.getSeconds()) +
        twelveHourFormat;
      return formattedTime;
    },

    dateTimeFormatterAppendLeadingZero(val) {
      if (val < 10) {
        return "0" + val;
      }
      return val;
    },
    showReloadWallet(val) {
      this.$store.commit("TOGGLE_RELOAD_WALLET_POPUP", val);
    },
    redirectToRoute(route) {
      this.$router.push(route);
    },
    getStateName(stateCode){
      for(let i=0; i<this.statesList.length; i++){
        if(this.statesList[i].value == stateCode){
          return this.statesList[i].text;          
        }
      }
    }
  }
};
</script>
